import { Hammer, Leaf, Building, Timer } from 'lucide-react';
import SpiracleLogo from '../../img/spiracle_logo.png';
import CTA from '../Cta';

function HobRepairService() {
    return (
        <div className="chimney-repair-container">
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">Termite Control Services</h1>
                    <p className="chimney-repair-subtitle">
                        Protect your valuable wood works with our comprehensive termite protection plan using the highly effective Drill-Fill-Seal method.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Our anti-termite treatment creates a complete protective barrier that stops termites from entering your home and destroying wooden furniture, doors and structures.
                    </p>
                    <p className="chimney-repair-subtitle">
                        The treatment module is highly effective, newly designed, convenient and totally hassle free for homeowners.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Book a free inspection and our experts will survey your premises and recommend the right termite treatment plan.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:8530352444")}
                        style={{ cursor: "pointer" }}>
                        Get a Free Inspection
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={SpiracleLogo} alt="Termite Control" />
            </div>

            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our Termite Control?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Building size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Wood Protection</h3>
                            <p className="chimney-repair-description">
                                Comprehensive protection plan for all your valuable wood works and structures.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Hammer size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Drill-Fill-Seal</h3>
                            <p className="chimney-repair-description">
                                Highly effective, newly designed treatment module with a hassle free process.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Leaf size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Eco-friendly</h3>
                            <p className="chimney-repair-description">
                                Best in class environmentally safe active ingredients, safe for your family.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Timer size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Long Lasting</h3>
                            <p className="chimney-repair-description">
                                Effective and long lasting protection that keeps termites away for years.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our Termite Control Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Termite Inspection</h3>
                        <p className="chimney-repair-step-description">
                            Detailed inspection to identify termite activity, entry points and affected wooden structures.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Drilling</h3>
                        <p className="chimney-repair-step-description">
                            Precision drilling at strategic locations to reach termite colonies deep inside the structure.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: Filling</h3>
                        <p className="chimney-repair-step-description">
                            Injection of best in class termiticide forming a complete protective chemical barrier.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Sealing</h3>
                        <p className="chimney-repair-step-description">
                            All drilled points are sealed neatly to restore the original look of your floors and walls.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default HobRepairService;